/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@import url(https://fonts.googleapis.com/css2?family=Muli:ital,wght@0,400;0[_ngcontent-%COMP%], 500[_ngcontent-%COMP%];0[_ngcontent-%COMP%], 700[_ngcontent-%COMP%];1[_ngcontent-%COMP%], 400&display=swap)[_ngcontent-%COMP%];.msisdn-wrapper[_ngcontent-%COMP%]{display:flex}.iti-flag[_ngcontent-%COMP%]{margin-top:2px;margin-left:17px;margin-right:10px}.msisdn-label[_ngcontent-%COMP%]{font-size:14px;color:#1a3349}.msisdn-value[_ngcontent-%COMP%]{font-size:12px;color:#9da2bd}"];
export { styles as styles };
